import EventService from 'src/modules/event/eventService';
import selectors from 'src/modules/event/list/eventListSelectors';
import { i18n } from 'src/i18n';
import exporterFields from 'src/modules/event/list/eventListExporterFields';
import Errors from 'src/modules/shared/error/errors';
import Exporter from 'src/modules/shared/exporter/exporter';

const prefix = 'EVENT_LIST';

const eventListActions = {
  FETCH_STARTED: `${prefix}_FETCH_STARTED`,
  FETCH_SUCCESS: `${prefix}_FETCH_SUCCESS`,
  FETCH_ERROR: `${prefix}_FETCH_ERROR`,

  RESETED: `${prefix}_RESETED`,
  TOGGLE_ONE_SELECTED: `${prefix}_TOGGLE_ONE_SELECTED`,
  TOGGLE_ALL_SELECTED: `${prefix}_TOGGLE_ALL_SELECTED`,
  CLEAR_ALL_SELECTED: `${prefix}_CLEAR_ALL_SELECTED`,

  PAGINATION_CHANGED: `${prefix}_PAGINATION_CHANGED`,
  SORTER_CHANGED: `${prefix}_SORTER_CHANGED`,

  EXPORT_STARTED: `${prefix}_EXPORT_STARTED`,
  EXPORT_SUCCESS: `${prefix}_EXPORT_SUCCESS`,
  EXPORT_ERROR: `${prefix}_EXPORT_ERROR`,

  doClearAllSelected() {
    return {
      type: eventListActions.CLEAR_ALL_SELECTED,
    };
  },

  doToggleAllSelected() {
    return {
      type: eventListActions.TOGGLE_ALL_SELECTED,
    };
  },

  doToggleOneSelected(id) {
    return {
      type: eventListActions.TOGGLE_ONE_SELECTED,
      payload: id,
    };
  },

  doReset: () => async (dispatch) => {
    dispatch({
      type: eventListActions.RESETED,
    });

    dispatch(eventListActions.doFetch());
  },

  doExport: () => async (dispatch, getState) => {
    try {
      if (!exporterFields || !exporterFields.length) {
        throw new Error('exporterFields is required');
      }

      dispatch({
        type: eventListActions.EXPORT_STARTED,
      });

      const filter = selectors.selectFilter(getState());
      filter["eventScheduleDetails"] = true;
      const response = await EventService.list(
        filter,
        selectors.selectOrderBy(getState()),
        null,
        null,
      );    
     
      const updatedItems = response.rows.flatMap(({ eventSchedule = [], ...rest }) =>        
        (eventSchedule.length > 0 ? eventSchedule.map(value => (
          { 
            ...rest,                                                            
            eventSchedule_name: (value as any).name,
            eventSchedule_from: (value as any).eventFrom,  
            eventSchedule_hour: (value as any).eventHour,  
            eventSchedule_contacts: (value as any).contacts
          }
        )): [
          { ...rest
          }])
      );
      
      new Exporter(
        exporterFields,
        i18n('entities.event.exporterFileName'),
      //).transformAndExportAsExcelFile(updatedItems);
      ).transformAndExportAsCsvFile(updatedItems);

      dispatch({
        type: eventListActions.EXPORT_SUCCESS,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: eventListActions.EXPORT_ERROR,
      });
    }
  },

  doChangePagination: (pagination) => async (
    dispatch,
    getState,
  ) => {
    dispatch({
      type: eventListActions.PAGINATION_CHANGED,
      payload: pagination,
    });

    dispatch(eventListActions.doFetchCurrentFilter());
  },

  doChangeSort: (sorter) => async (dispatch, getState) => {
    dispatch({
      type: eventListActions.SORTER_CHANGED,
      payload: sorter,
    });

    dispatch(eventListActions.doFetchCurrentFilter());
  },

  doFetchCurrentFilter: () => async (
    dispatch,
    getState,
  ) => {
    const filter = selectors.selectFilter(getState());
    const rawFilter = selectors.selectRawFilter(getState());
    dispatch(eventListActions.doFetch(filter, rawFilter, true));
  },

  doFetch: (filter?, rawFilter?, keepPagination = false) => async (
    dispatch,
    getState,
  ) => {
    try {
      dispatch({
        type: eventListActions.FETCH_STARTED,
        payload: { filter, rawFilter, keepPagination },
      });

      const response = await EventService.list(
        filter,
        selectors.selectOrderBy(getState()),
        selectors.selectLimit(getState()),
        selectors.selectOffset(getState()),
      );

      dispatch({
        type: eventListActions.FETCH_SUCCESS,
        payload: {
          rows: response.rows,
          count: response.count,
        },
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: eventListActions.FETCH_ERROR,
      });
    }
  },
};

export default eventListActions;
